import { styled, Caption, Body } from '@teko/ds-desktop';
import React, { useState } from 'react';
import { MenuPanel, MAX_MENU_ITEMS } from './MenuPanel.es.js';
import { TekoLink } from '../TekoLink/TekoLink.es.js';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({
  type,
  align = "left",
  menuItems
}) => {
  const [activeMenu, setActiveMenu] = useState(void 0);
  const verticalMenuWidth = "12.375rem";
  const horizontalMenuHeight = "3rem";
  const megaMenuHeight = "28.5rem";
  if (!menuItems.length)
    return null;
  const hideMenuPanel = () => {
    setActiveMenu(void 0);
  };
  const renderVerticalMegaMenu = () => {
    return /* @__PURE__ */ React.createElement(MegaMenuWrapper, {
      className: "vertical-mega-menu-wrapper",
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ React.createElement(VerticalMegaMenu, {
      className: `vertical-mega-menu ${activeMenu ? "active" : ""}`,
      width: verticalMenuWidth,
      height: megaMenuHeight
    }, menuItems.slice(0, MAX_MENU_ITEMS).map((item, index) => /* @__PURE__ */ React.createElement(TekoLink, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ React.createElement(VerticalMenuItem, {
      className: "vertical-mega-menu-item",
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ React.createElement(VerticalMenuItemImageMegaMenuWrapper, null, /* @__PURE__ */ React.createElement(EnhancedImage, {
      src: item.icon,
      height: "100%"
    })), /* @__PURE__ */ React.createElement(Caption, {
      level: 2,
      line: 1,
      style: { flex: 1 }
    }, item.name))))), /* @__PURE__ */ React.createElement(VerticalMenuPanel, {
      className: `vertical-mega-menu-panel ${activeMenu ? "active" : ""}`,
      type,
      verticalMenuWidth,
      menu: menuItems,
      activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  const renderHorizontalMegaMenu = () => {
    return /* @__PURE__ */ React.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ React.createElement(HorizontalMegaMenu, {
      height: horizontalMenuHeight,
      align
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ React.createElement(TekoLink, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ React.createElement(HorizontalMenuItem, {
      height: horizontalMenuHeight,
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ React.createElement(Body, {
      level: 2,
      line: 1,
      hoverColor: "primary500"
    }, item.name))))), /* @__PURE__ */ React.createElement(HorizontalMenuPanel, {
      type,
      className: activeMenu ? "active" : "",
      horizontalMenuHeight,
      menu: menuItems,
      activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  if (type === "vertical")
    return renderVerticalMegaMenu();
  return renderHorizontalMegaMenu();
};
const MegaMenuWrapper = styled.div`
  position: relative;
`;
const VerticalMenuPanel = styled(MenuPanel)(({
  verticalMenuWidth,
  theme
}) => `
  position: absolute;
  top: 0;
  width: calc(75rem - ${verticalMenuWidth});
  left: ${verticalMenuWidth};
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`);
const HorizontalMenuPanel = styled(MenuPanel)(({
  horizontalMenuHeight,
  theme
}) => `
  position: absolute;
  left: 0;
  right: 0;
  top: ${horizontalMenuHeight};
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  border-bottom-right-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  border-bottom-left-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
`);
const VerticalMegaMenu = styled.div(({ theme, width, height }) => `
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  position: relative;
  overflow: hidden;
  width: ${width};
  height: ${height};
  z-index: 980;
  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`);
const HorizontalMegaMenu = styled.div(({ theme, height, align }) => `
  height: ${height};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  width: 100%;
  overflow: hidden;
  ${align === "right" ? `display: flex;
        justify-content: flex-end;` : align === "space-between" ? `display: flex;
        justify-content: space-between;` : ""}
`);
const VerticalMenuItem = styled.div(({ theme }) => `
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${theme == null ? void 0 : theme.spacing.s8};
  padding: 0 ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  overflow: hidden;
  &:hover {
    background-color: ${theme == null ? void 0 : theme.colors.primary50};
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const HorizontalMenuItem = styled.div(({ theme, height }) => `
  padding: 0 ${theme == null ? void 0 : theme.spacing.s12};
  height: ${height};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  &::after {
    content: '';
    height: 2px;
    background-color: ${theme == null ? void 0 : theme.colors.primary500};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
    &::after {
      opacity: 1;
    }
  }
`);
const VerticalMenuItemImageMegaMenuWrapper = styled.div`
  width: 22px;
  height: 22px;
`;

export { MegaMenu };
